import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize
} from '@material-ui/core';
import {Controller, SubmitHandler, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import './StopTicketTimerDialogStyles.scss';
import {stopTicketTimer} from '@shared/services/WorkflowServices';
import Storage from 'src/utils/Storage';
import {
  PriorAuthConstants,
  TICKETING_SYSTEM_MODULE_NAME_TO_MODULE_ID_MAPPER
} from '@shared/constants/Mapping';
import {useDispatch, useSelector} from 'react-redux';
import {_resetTicketTimer} from '@shared/store/actions/TicketTimerActions';
import {IAllPossibleTicketModules} from '../../hooks/useTicketingSystemPermission';

interface stopTicketTimerDialogProps {
  open: boolean;
  onClose: (response: 'confirm' | 'cancel') => void;
  clinicGroupId: number | undefined;
  clinicId: number | undefined;
  ticketId: number | undefined;
  notes?: string;
}
interface stopTicketTimerDialogFormFields {
  notes: string;
}
const StopTicketTimerDialog = (
  props: stopTicketTimerDialogProps
): JSX.Element => {
  const {
    open,
    onClose,
    clinicGroupId,
    clinicId,
    ticketId,
    notes: defaultNote
  } = props;
  const dispatch = useDispatch();

  const TicketTimerInfo = useSelector(
    (state: any) => state.PriorAuthTicketTimer
  );
  const {
    // startTime: selectedPatientTicketStartTime,
    logId: ticketTimerLoggingId
  } = TicketTimerInfo;

  let localStorageData: any = Storage.getItem(
    PriorAuthConstants.STORAGE_PRIOR_AUTH_TIMER_DATA
  );
  if (localStorageData) {
    localStorageData = JSON?.parse?.(localStorageData);
  }
  const {
    control,
    handleSubmit,
    formState: {isSubmitting}
  } = useForm<stopTicketTimerDialogFormFields>({
    mode: 'all',
    defaultValues: {
      notes: defaultNote
    }
  });
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const handleFormSubmit: SubmitHandler<stopTicketTimerDialogFormFields> = async data => {
    const date = new Date();
    const utcDate = date.toUTCString();
    try {
      // let ticketTimerData: any = Storage.getItem(PriorAuthConstants.STORAGE_PRIOR_AUTH_TIMER_DATA);
      // ticketTimerData = JSON.parse(ticketTimerData || null);
      // const timeDiff = date.getTime() - (selectedPatientTicketStartTime || 0);
      // const timeDiffInSeconds = Math.floor(timeDiff / 1000);
      let trimmedNotes = null;
      if (data.notes && typeof data.notes === 'string' && data.notes.trim()) {
        trimmedNotes = data.notes.trim();
      }
      const payload: any = {
        stop_time: utcDate,
        // time_spent: timeDiffInSeconds,
        notes: trimmedNotes
      };
      if (clinicGroupId && clinicId && ticketId) {
        const res = await stopTicketTimer(
          clinicGroupId,
          clinicId,
          ticketId,
          localStorageData.logId ?? ticketTimerLoggingId,
          payload,
          // TODO: MAKE THE TIMER GENERIC
          {
            module:
              TICKETING_SYSTEM_MODULE_NAME_TO_MODULE_ID_MAPPER[
                localStorageData?.module as IAllPossibleTicketModules
              ]
          }
        );
        if (res) {
          enqueueSnackbar(
            t('TICKETING_SYSTEM.TIMER.STOP_TIMER'),
            SnackBarConfig('s')
          );
          Storage.setItem(
            PriorAuthConstants.STORAGE_PRIOR_AUTH_TIMER_DATA,
            JSON.stringify({
              startTime: null,
              stopTime: null,
              isTmerRunning: false,
              patientId: null,
              ticketId: null,
              logId: null
            })
          );
          dispatch(_resetTicketTimer());
          onClose('confirm');
        }
      }
    } catch (error: any) {
      enqueueSnackbar(
        error?.message || t('ERROR WHILE FETCHING INVOICE SERVICE DATA'),
        SnackBarConfig('e')
      );
    }
  };
  return (
    <Dialog
      maxWidth={'md'}
      open={open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={() => onClose('cancel')}
      className="stop-timer-dialog">
      <DialogTitle disableTypography>
        {t('TICKETING_SYSTEM.TIMER.STOP_TICKET_TIMER_DIALOG.TITLE')}
      </DialogTitle>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <DialogContent dividers>
          <Controller
            name="notes"
            control={control}
            render={inputProps => (
              <div className="notes-input-wrapper">
                <p>{t('INCOMING_SMS.MARK_AS_DONE_DIALOG.NOTES')}</p>
                <TextareaAutosize
                  rowsMax={10}
                  rows={4}
                  aria-label="notes"
                  placeholder={t(
                    'INCOMING_SMS.MARK_AS_DONE_DIALOG.NOTES_PLACEHOLDER'
                  )}
                  {...inputProps}
                  className="app-text-area text-area-auto-size"
                />
              </div>
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isSubmitting}
            onClick={() => onClose('cancel')}
            variant="text"
            size={'small'}>
            {t('COMMON.CANCEL')}
          </Button>
          <Button
            disabled={isSubmitting}
            variant="contained"
            type="submit"
            size={'small'}
            color="primary">
            {t('Save')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default StopTicketTimerDialog;
